import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss']
})
export class InvoiceDetailsComponent implements OnInit {

  constructor(private title: Title, private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.get('title_invoice_data').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

}
